import React from "react";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import AuthService from "js/utils/AuthService";
import base from "./Base";
import { exportURL } from "js/constants";
export default params => {
  let exporting = false;
  return {
    ...base(),
    label: params.label,
    icon: <DownloadIcon />,
    tooltip: params.tooltip,
    show: () => AuthService.hasPerms(params.perms),
    onclick: () => {
      if (exporting) return;
      exporting = true;
      window.location = `${exportURL}/${params.path}?${params.queryString(
        params.itemId
      )}`;
      setTimeout(() => {
        exporting = false;
      }, 1500);
    }
  };
};
